<template>
    <v-btn
        text
        dark
        class="btn-without-border"
        title="Přijmout"
        @click.stop="accept"
    >
        Přijmout
    </v-btn>
</template>

<script>
    import { ACCEPT_JOIN_REQUEST } from '../../store/actions/team'

    export default {
        name: 'TeamRequestControlAccept',
        props: {
            requestId: {
                type: String,
                required: true,
            },
        },
        methods: {
            async accept () {
                try {
                    this.$emit('control-action', { state: 'loading' });
                    await this.$store.dispatch('team/' + ACCEPT_JOIN_REQUEST, { requestId: this.requestId });
                    this.$emit('control-action', { state: 'accepted' });
                    this.$toast.success('Hráč byl úspěšně přijat do týmu.');
                } catch (e) {
                    const message = e.response.data.message || 'Při přijetí žádosti došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                    this.$emit('control-action', { state: null });
                }
            },
        },
    }
</script>
